module.exports = __webpack_public_path__ + "img/Screen-L@2x-design.a6713b81.png";